<template>
    <v-card
    class="side-bar"
    :style="`
    ${width?`width: ${width};`:''}
    ${isMobile?`height: ${mobile_height}px !important;`:''}
    `
    "
    >
    <div class="side-bar-activator" v-if="!isMobile">
      <slot name="side-bar-activator"/>
    </div>
    <div
      class="content"
      :style="buttons || button?'height: calc(100% - 48px - 6px) !important;':''"
      >
      <slot name="content"/>
    </div>
    <div
      class="buttons color-4"
      v-if="buttons || button"
      >
      <div v-if="button" class="center">
        <slot name="button-center"/>
      </div>
      <div v-if="buttons" class="left">
        <slot name="button-left"/>
      </div>
      <div v-if="buttons" class="right">
        <slot name="button-right"/>
      </div>
    </div>
  </v-card>
</template>
<script>
  export default {
    props: ['buttons', 'button', 'width', 'isMobile'],
    computed: {
      mobile_height() {
        return window.innerHeight;
      }
    }
  }
</script>
<style scoped>
  .side-bar {
    position: fixed;
    height: calc(100vh - 48px - 30px) !important;
    width: 330px;
    right: 0px;
    z-index: 120;
    /* will-change: transform; */
    overflow: hidden;
    flex-shrink: 0;
    transition: all 0.2s ease-out;
  }
  .buttons {
    position: sticky;
    position: -webkit-sticky;
    bottom: 0px;
    width: 100%;
    display: flex;
  }
  .left {
    width: 100%;
    padding: 6px 3px 6px 6px;
  }
  .right {
    width: 100%;
    padding: 6px 6px 6px 3px;
  }
  .center {
    width: 100%;
    padding: 6px 6px 6px 6px;
  }
  .content {
    position: relative;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0px !important;
    padding: 3px;
  }
  .side-bar-activator {
    position: fixed;
    top: 50%;
    z-index: 4;
  }
</style>
